import React, { ReactElement } from 'react';

export const withDataTestIdProxy =
  <Element extends ReactElement>(element: () => Element) =>
  ({
    dataTestId,
    ...restProps
  }: Element['props'] & {
    dataTestId?: string;
  }): ReactElement =>
    React.cloneElement(element(), {
      ...restProps,
      ...(dataTestId && { 'data-test-id': dataTestId }),
    });

type DataTestIdProxyProps = {
  children: ReactElement;
  dataTestId?: string;
};

export const DataTestIdProxy = ({
  children,
  dataTestId,
}: DataTestIdProxyProps): ReactElement => withDataTestIdProxy(() => children)({ dataTestId });
